
import { mapState, mapActions, mapGetters } from "vuex";
import invoicesTableRow from "./invoices-table-row.vue";
export default {
  components: { invoicesTableRow },
  props: {
    search: {
      default: ""
    }
  },
  data() {
    return {
      loading: false,
      titles: [
        { value: "brand", label: "Brand" },
        { value: "invoiceNo", label: "Invoice No." },
        { value: "billedOn", label: "Billed On" },
        { value: "amount", label: "Amount" },
        { value: "dueDate", label: "Due Date" },
        { value: "payment", label: "Payment" }
      ]
    };
  },
  mounted() {
    this.loading = true;
    this.getInvoices()
      .then(() => {})
      .finally(() => {
        this.loading = false;
      });
  },
  computed: {
    ...mapState("payment", ["invoices"]),
    ...mapGetters("payment", ["pendingInvoices", "completedInvoices"]),
    pendingInvoicesList() {
      return this.pendingInvoices.filter((el) => {
        return (
          String(el.id).indexOf(this.search) >= 0 ||
          String(el.amount).indexOf(this.search) >= 0
        );
      });
    },
    completedInvoicesList() {
      return this.completedInvoices.filter((el) => {
        return (
          String(el.id).indexOf(this.search) >= 0 ||
          String(el.amount).indexOf(this.search) >= 0
        );
      });
    }
  },
  methods: {
    ...mapActions("payment", ["getInvoices"])
  }
};
